"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";
      try {
        const res = await fetch(`${apiUrl}/api/testimonial/public?limit=50`);
        if (!res.ok) throw new Error("Failed to fetch testimonials");
        const data = await res.json();
        
        if (data.success && data.data && data.data.testimonials && data.data.testimonials.length > 0) {
          // Filter to only active testimonials if required, but public API usually only returns active ones
          const activeTestimonials = data.data.testimonials.filter(item => item.isActive !== false);
          setTestimonials(activeTestimonials);
        }
      } catch (error) {
        console.warn("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  // For the infinite vertical scrolling marquee to work seamlessly, we duplicate the array of testimonials
  const displayList = [...testimonials, ...testimonials];
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section className="">
      <div className="rating" data-aos="fade-up" data-aos-delay="0">
        <h2 className="Testimonial-bg">Testimonial</h2>
        <div 
          className="carouselA"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div 
            className="groupA"
            style={{ animationPlayState: isHovered ? "paused" : "running" }}
          >
            {displayList.map((item, index) => {
              const ratingVal = Math.min(5, Math.max(1, item.rating || 5));
              const starsStr = "★".repeat(ratingVal) + "☆".repeat(5 - ratingVal);
              
              return (
                <div 
                  className="testimonial-card" 
                  key={`${item._id || index}-${index}`}
                  onMouseEnter={(e) => {
                    setIsHovered(true);
                    e.currentTarget.style.borderColor = "#F48428";
                    e.currentTarget.style.boxShadow = "0 0 12px rgba(244, 132, 40, 0.4), inset 0 0 8px rgba(244, 132, 40, 0.15)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.backgroundColor = "rgba(35, 35, 35, 0.95)";
                  }}
                  onMouseLeave={(e) => {
                    setIsHovered(false);
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.15)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.4)";
                    e.currentTarget.style.transform = "none";
                    e.currentTarget.style.backgroundColor = "rgba(28, 28, 28, 0.75)";
                  }}
                  style={{
                    transition: "all 0.3s ease-in-out",
                    cursor: "pointer"
                  }}
                >
                  <div className="stars">{starsStr}</div>
                  <p className="mt-3 text-start">{item.message}</p>
                  <hr className="line" />
                  <h3>{item.name}</h3>
                  {item.designation && <small>{item.designation}</small>}
                </div>
              );
            })}
          </div>
        </div>
        <div
          className="text-center mt-5"
          data-aos="fade-up"
          data-aos-delay="0"
        >
          <Link href="/reviews" className="cta-button">
            View All Reviews <span className="arrow">↗</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
